<script setup>
  import { useRoute } from "vue-router";

  import BaseFooter from "./BaseFooter.vue";
  import BaseHeader from "./BaseHeader.vue";
  import ScrollTopButton from "@/components/ScrollTopButton.vue";

  const route = useRoute();

  const checkNoPaddingRouter = () => {
    const noPaddingRouters = ["Home", "ExamSplan"];
    // 배경색(#f5f6fb)이 푸터까지 이어져야 하는 탭 페이지 섹션은 경로 기준으로 판단
    const noPaddingPaths = ["/my-test", "/board"];
    const isMatched =
      noPaddingRouters.some((name) => route.name?.includes(name)) ||
      noPaddingPaths.some((path) => route.path.startsWith(path));
    return isMatched ? "pb-0" : "";
  };
</script>

<template>
  <div class="layout-container">
    <BaseHeader />
    <main :class="checkNoPaddingRouter()"><router-view /></main>
    <BaseFooter />
    <ScrollTopButton />
  </div>
</template>
